import { render, staticRenderFns } from "./qspiPerformance.vue?vue&type=template&id=2305198e&scoped=true"
import script from "./qspiPerformance.vue?vue&type=script&lang=js"
export * from "./qspiPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2305198e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2305198e')) {
      api.createRecord('2305198e', component.options)
    } else {
      api.reload('2305198e', component.options)
    }
    module.hot.accept("./qspiPerformance.vue?vue&type=template&id=2305198e&scoped=true", function () {
      api.rerender('2305198e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/QSPIReport/qspiPerformance.vue"
export default component.exports